var LanguageMenu = {
	data:null,
	menuButton:"#menubar_langicon",
	
	init: function() {
		AppEvent.on(player, "afterLoad", LanguageMenu.afterLoad);
		//console.log("Lang MEnu");
	},

	go: function(ln) {
		//console.log(LanguageMenu.data.place_id);
		//return;

		if (player.offline) {
			//player.setLang(LanguageMenu.data.folder.languages[ln]);
//			window.location.href="index.html?setlang=" + LanguageMenu.data.folder.languages[ln];
			window.location.href = LanguageMenu.data.folder.languages[ln] + ".html?setlang=" + LanguageMenu.data.folder.languages[ln];
		} else {
			if (LanguageMenu.data.folder.languages[ln] != LanguageMenu.data.lang) document.location = "index.php?id=" + LanguageMenu.data.place_id + "&lng=" + LanguageMenu.data.folder.languages[ln];
			else $("#languages").hide();
		}
	},
	
	show: function(force) {
		var chl = "";
		
		//console.log(LanguageMenu.data.folder.languages.length);
		
		if ((LanguageMenu.data.folder.languages && LanguageMenu.data.folder.languages.length > 1) && (LanguageMenu.data.lang == null || LanguageMenu.data.lang == "" || force)) {
			$("#languages").show();
			$("#languages").html("");
			AppEvent.trigger(LanguageMenu, "LANGSELECTION.SHOW", {});

			if (force) {
				$("#languages").addClass("tab");
				menubar.setActive(this);
			}
			
			for(var ln in LanguageMenu.data.folder.languages) {
				chl += "<div class='lang'><a href='javascript:void(null);' onclick='LanguageMenu.go(\"" + ln + "\")'><img src='flags/hd/" + LanguageMenu.data.folder.languages[ln].toLowerCase() + ".png'></a></div>";
			}
			$("#languages").html("<div class='langlist'>Select language<br><br>" + chl + "</div>");
		} else {
			var deflang = LanguageMenu.data.lang ? LanguageMenu.data.lang : "";
			if (deflang == "") deflang = "PL";
			$("#glyph_langicon").attr("src","flags/hd/" + deflang.toLowerCase() + ".png");
			if (LanguageMenu.data.folder.languages.length <= 1) $("menubar_langicon").hide(); else $("menubar_langicon").show();
		}
	},
	
	afterLoad: function(data) {
		LanguageMenu.data = data;
		//console.log("ID: " + LanguageMenu.data.place_id);
		LanguageMenu.show(false);
	},
	
	close: function() {
		$("#languages").hide();
	}
}

PluginManager.add(LanguageMenu);